import { userLoginInfo } from '@/apiUtils'
export default {
	namespaced: true,
	state() {
		return {
			/** 标识 */
			stateId: 0,
			/** 成员身份 */
			identity: 0,
			/** 部门身份 */
			deptId: 0,
			/** 部门名 */
			deptName: '',
			/** 是否签名 */
			noticeSign: 0,
			/** 已勾选的人员列表-导出汇总表*/
			selectedSummaryTableList: [],
			/** 已勾选的人员列表-导出个人述职报告*/
			selectedPersonReportList: [],
			/** 显示绩效考核的标识 */
			isLeader: null,
			/** 显示附件审核的标识 */
			reviewer: null
		}
	},
	mutations: {
		/** 设置标识 */
		setStateId(state, stateId) {
			state.stateId = stateId
		},
		/** 设置成员身份 */
		setIdentity(state, identity) {
			state.identity = identity
		},
		/** 设置部门身份 */
		setDeptId(state, deptId) {
			state.deptId = deptId
		},
		/** 设置部门名 */
		setDeptName(state, deptName) {
			state.deptName = deptName
		},
		/** 是否签名 */
		setNoticeSign(state, noticeSign) {
			state.noticeSign = noticeSign
		},
		/** 设置已勾选的人员列表-导出汇总表 */
		setSelectedSummaryTableList(state, data) {
			state.selectedSummaryTableList = data
		},
		/** 设置已勾选的人员列表-导出个人述职报告 */
		setSelectedPersonReportList(state, data) {
			state.selectedPersonReportList = data
		},
		/** 显示绩效考核的标识 */
		setIsLeader(state, data) {
			state.isLeader = data
		},
		/** 显示附件审核的标识 */
		setReviewer(state, data) {
			state.reviewer = data
		}
	},
	actions: {
		async getLoginInfo({ commit }) {
			const type = sessionStorage.getItem('type')
			if (type !== 'salaryType') {
				const { data = {} } = await userLoginInfo()

				if (data.identity !== undefined) {
					commit('setIdentity', data.identity)
				}

				if (data.deptId !== undefined) {
					commit('setDeptId', data.deptId)
				}

				if (data.deptName !== undefined) {
					commit('setDeptName', data.deptName)
				}

				if (data.noticeSign !== undefined) {
					commit('setNoticeSign', data.noticeSign)
				}
			}
		}
	}
}
